<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- NAME -->
        <FormItem prop="name" :label="schema.name.label">
          <Input v-model="formData.name" :placeholder="schema.name.label"/>
        </FormItem>

        <!-- IMAGE -->
        <div v-if="formData.image_url" class="upload_image">
          <img :src="image_url_full"/>
          <div class="upload_image_cover">
            <Icon type="ios-trash-outline" @click.native="deleteImage"></Icon>
          </div>
        </div>

        <Upload
          class="mb-30"
          v-else
          type="drag"
          :action="upload_url"
          :headers="{ Authorization: 'Bearer ' + token }"
          :on-success="onSuccessImageUpload"
        >
          <div style="padding: 20px 0">
            <Icon type="md-cloud-upload" size="50"/>
            <p>Загрузите изображение</p>
          </div>
        </Upload>

        <!-- ADDRESS -->
        <FormItem prop="address" :label="schema.address.label">
          <Input
            type="textarea"
            v-model="formData.address"
            :rows="4"
            :placeholder="schema.address.label"
          />
        </FormItem>

        <!-- DESCRIPTION -->
        <FormItem prop="description" :label="schema.description.label">
          <Input
            type="textarea"
            v-model="formData.description"
            :rows="4"
            :placeholder="schema.description.label"
          />
        </FormItem>

        <!-- TIMEZONE -->
        <FormItem prop="timezone" :label="schema.timezone.label" class="mb-50">
          <Select v-model="formData.timezone" filterable>
            <Option
              v-for="item in schema.timezone.choices"
              :value="item.value"
              :key="item.value"
            >{{ item.display_name }}
            </Option
            >
          </Select>
        </FormItem>


        <!-- DEFAULT -->
        <FormItem prop="default">
          <div class="switch-custom">
            <i-switch v-model="formData.default"></i-switch>
            <span>{{schema.default.label}}</span>
          </div>

        </FormItem>

        <!-- NULLABLE REST -->
        <FormItem prop="default">
          <div class="switch-custom">
            <i-switch v-model="formData.nullable_rest"></i-switch>
            <span>{{schema.nullable_rest.label}}</span>
          </div>

        </FormItem>
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button
        type="info"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      >
        <Icon type="md-checkmark"/>
      </Button>
    </div>
  </div>
</template>

<script>
    //import {http, base_url} from '../../http.js'
    import { base_url, server_addr } from "../../http.js";
    import {BaseFormData} from "../../base/base_form_v2.js";

    let _app = BaseFormData();

    _app.data = function () {
        return {
            loading: true,
            baseRules: {},
            excludeFieldsRules: [],
            validForm: false,
            isChanged: false,

            upload_url: base_url + "/store/upload/",

            formData: {
                name: "",
                address: "",
                description: "",
                default: "",
                image: "",
                image_url: "",
                nullable_rest: true
            },

            formDefaultInitData: {
                name: "",
                address: "",
                description: "",
                default: "false",
                nullable_rest: true
            },

            formSelectOptions: {
                // type: []
            },
        };
    };

    _app.computed.token = function () {
        return this.$store.state.access_token;
    };
    _app.computed.image_url_full = function() {
        return server_addr + this.formData.image_url;
    };

    // Загрузка и удаление картинки
    _app.methods.onSuccessImageUpload = function(response, filename) {
        // console.log(response);
        this.formData.image = response.filename;
        this.formData.image_url = response.url;
    };
    _app.methods.deleteImage = function() {
        this.formData.image = "";
        this.formData.image_url = "";
    };


    export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/store/storeForm.vue